import { ActionCard } from '@pcln/horizon'
import { Flex, Layout } from 'pcln-design-system'

import { getActionCardLinkProps, ICON_SYMBOL, type Banner } from './utils'

export default function WhyPricelineBanner({ content }: Readonly<Banner>) {
  return (
    <Flex>
      <Layout variation={['50-50', undefined, undefined, undefined, '25-25-25-25']} rowGap='md' gap='md'>
        {content?.map(({ iconName, heading, subtext, href }) => (
          <ActionCard
            key={iconName}
            mediaType='icon'
            mediaContent={ICON_SYMBOL[iconName]}
            heading={heading}
            body={subtext}
            className='h-full'
            {...getActionCardLinkProps(href)}
          />
        ))}
      </Layout>
    </Flex>
  )
}
